import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replace' })
export class ReplacePipe implements PipeTransform {
  /*
  This pipe replaces all occurrences of a specified string in the input string with another specified string.
  It uses a regular expression to perform the replacement globally (i.e., for all occurrences).
  The pipe takes three arguments:
    1. value: The input string in which the replacement will occur.
    2. toReplace: The string that will be replaced.
    3. replaceChar: The string that will replace the occurrences of toReplace.
  If any of the arguments are falsy (e.g., null, undefined, empty string), the original value is returned.

  Example usage: {{ 'snack_case_str' | replace : '_' : ' ' }} will return 'snake case str'.
  */
  transform(value: string, toReplace: string, replaceChar: string): string {
    if (!value || !toReplace || !replaceChar) {
      return value;
    }
    return value.replace(new RegExp(toReplace, 'g'), replaceChar);
  }
}
